import { all, call, fork, getContext, put, select, spawn, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { TealiumCustomerIdentity } from '@as-react/common-types';
import AuthApi from '../../../api/auth/AuthApi';
import SessionAPI from '../../../api/SessionAPI';
import CustomerApi from '../../../api/customer/CustomerApi';
import AuthSocialLoginFacebookApi from '../../../api/auth/AuthSocialLoginFacebookApi';
import { GeneralActionTypes, SessionActionTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { wishListActions } from '../../wishList/actions/WishListActions.creators';
import sessionActions from '../actions/SessionActions.creators';
import { makeGetHasConsentOnMarketingCookies } from '../../cookieConsent/selectors/CookieConsentSelector';
import { analyticsActions } from '../../analytics/actions/AnalyticsActions.creators';
import { CookieUtil } from '@as-react/common-utils';
function* customEventSaga() {
    yield takeEvery(GeneralActionTypes.CUSTOM_EVENT, handleCustomEvent);
}
function* handleCustomEvent(action) {
    switch (action.payload.eventType) {
        case EventEnum.USER_LOGGED_IN:
            yield spawn(getSession);
            break;
        default:
            break;
    }
}
export function* getSessionSaga() {
    yield takeLatest(SessionActionTypes.INIT, getSession);
}
export function* logoutFromSessionSaga() {
    yield takeLatest(SessionActionTypes.LOGOUT, logoutFromSession);
}
function* getSession() {
    try {
        const { isShopLanding, shopNumber, servicesEndpoint, defaultRequestParams } = yield getContext('aemConfiguration');
        let requestParams = Object.assign({}, defaultRequestParams);
        if (isShopLanding && shopNumber) {
            requestParams = Object.assign(Object.assign({}, defaultRequestParams), { shopNumber });
        }
        const sessionData = yield call(SessionAPI.infoRequest, servicesEndpoint, requestParams);
        if (!!sessionData.error && sessionData.error === 'invalid_request') {
            yield call(startAnonymousSession);
            const anonymousSessionData = yield call(SessionAPI.infoRequest, servicesEndpoint, requestParams);
            yield put(sessionActions.createSetAction(anonymousSessionData));
        }
        else {
            yield put(sessionActions.createSetAction(sessionData));
        }
        yield fork(analyticsCustomerIdentification);
    }
    catch (_a) { }
}
function* analyticsCustomerIdentification() {
    const consentMarketing = yield select(makeGetHasConsentOnMarketingCookies());
    const userID = CookieUtil.get('_UUID') || CookieUtil.get('customerID');
    if (consentMarketing && userID) {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        try {
            const customerInfo = yield CustomerApi.getTealiumCustomerData(servicesEndpoint, defaultRequestParams.mainWebshop);
            yield put(analyticsActions.customerIdentification({
                identity: TealiumCustomerIdentity.IDENTIFIED,
                customerInfo,
            }));
            return;
        }
        catch (_a) { }
    }
    yield put(analyticsActions.customerIdentification({ identity: TealiumCustomerIdentity.ANONYMOUS }));
}
function* logoutFromSession() {
    try {
        const { defaultRequestParams, servicesEndpoint, rootWithoutFinalSlash } = yield getContext('aemConfiguration');
        yield call(AuthApi.logout, servicesEndpoint, defaultRequestParams);
        if (AuthSocialLoginFacebookApi.isInitialized()) {
            const isAuthenticated = yield call(AuthSocialLoginFacebookApi.isAuthenticated);
            if (isAuthenticated) {
                yield call(AuthSocialLoginFacebookApi.logoutWithFacebook);
            }
        }
        EventUtil.dispatch(EventEnum.USER_LOGGED_OUT);
        yield fork(startAnonymousSession);
        yield put(wishListActions.logout());
        yield take(WishListActionTypes.LOGGED_OUT);
        const url = rootWithoutFinalSlash;
        if (url.length > 0 && url.indexOf('.html') === -1) {
            // no page extention found.
            window.location.href = `${url}.html`;
        }
        else if (url === '') {
            window.location.href = '/';
        }
        else {
            window.location.href = url;
        }
    }
    catch (_a) { }
}
function* startAnonymousSession() {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield call(AuthApi.login, servicesEndpoint, defaultRequestParams, undefined, undefined, false);
    }
    catch (_a) { }
}
export default function* sessionSaga() {
    yield all([customEventSaga(), getSessionSaga(), logoutFromSessionSaga()]);
}
